import { Button } from "Components/atoms/Button";
import { Icon } from "Components/atoms/Icon";

import AppImage from "assets/images/mascots/app.png";
import TravelImage from "assets/images/mascots/travel.png";
import AppleStoreImage from "assets/images/stories/apple.png";
import GooglePlayImage from "assets/images/stories/google.png";

import { requestAppDownload } from "shared/services/appDownload";
import {
  AlertCard,
  AlertContent,
  AlertGradient,
  AlertImage,
  AppCard,
  AppContent,
  AppImageStyled,
  CardsSection,
  StoreButtons,
} from "./styles";

const URL_VOOPTER_CREATE_ALERT = "https://voopter.com.br/alertas";

const openExternalLink = (url: string) => {
  window.open(url, "_blank", "noreferrer");
};

/** Cards de criação de alertas e download do aplicativo. */
export function CallToActionBlockTemplate() {
  return (
    <CardsSection>
      <AlertCard>
        <AlertContent>
          <h2>Seja avisado quando sua passagem ideal chegar</h2>
          <p>
            Crie alertas de preços e nós te avisamos quando encontrarmos a
            passagem aérea no valor que você escolheu!
          </p>
          <Button
            label="Criar meu alerta"
            icon={<Icon library="md" name="MdNotificationsNone" size="small" />}
            backgroundColor="yellow"
            color="mediumGray"
            fontWeight="medium"
            size="small"
            onClick={() => openExternalLink(URL_VOOPTER_CREATE_ALERT)}
          />
        </AlertContent>
        <AlertGradient />
        <AlertImage src={TravelImage} alt="Viajante com uma mala" />
      </AlertCard>

      <AppCard>
        <AppContent>
          <strong>Passagens baratas direto na sua mão</strong>
          <h2>Baixe agora o App da Voopter</h2>
          <p>
            Com o aplicativo do Voopter, você encontra passagens aéreas mais
            econômicas diretamente do seu celular.
          </p>
        </AppContent>
        <AppImageStyled src={AppImage} alt="Aplicativo da Voopter" />
        <StoreButtons>
          <Button
            image={GooglePlayImage}
            onClick={() => requestAppDownload("android")}
            size="ghost"
          />
          <Button
            image={AppleStoreImage}
            onClick={() => requestAppDownload("ios")}
            size="ghost"
          />
        </StoreButtons>
      </AppCard>
    </CardsSection>
  );
}
